import abuse from './abuse'
import auth from './auth'
import endpoints from './endpoints'
import report from './report'

export default {
    abuse,
    auth,
    endpoints,
    report,
}
